import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from 'public/app/components/components.module';
import { CallbackComponent } from './callback.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        ComponentsModule,
        TranslateModule
    ],
    declarations: [
        CallbackComponent
    ]
})
export class CallbackModule {}
